<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{title}}
        <div class="card-header-actions">
          <a class="btn btn-secondary btn-sm" :href="travel.form.link" target="_blank" rel="noopener noreferrer" style="margin-right: 3px;">Ver formulario</a>
          <CButton color="info" size="sm" @click="questionModal()">Nueva Pregunta</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="questions"
        :fields="fields"
        :items-per-page="30"
        :dark="dark"
        pagination
        :tableFilter="{label: 'Buscar: ', placeholder: ' '}"
        :itemsPerPageSelect="{label: 'Preguntas por página: ', values: [10,20,30,50,100]}"
      >
        <template #position="{item}"><td class="text-center w100">{{item.position}}</td></template>
        <template #type="{item}"><td class="text-center w100">{{item.type == 'text' ? 'Texto' : (item.type == 'options' ? 'Opciones' : (item.type == 'permission' ? 'Permiso' : (item.type == 'date' ? 'Fecha' : (item.type == 'file' ? 'Archivo' : (item.type == 'number' ? 'Numérico' : 'N/A')))))}}</td></template>
        <template #question="{item}"><td class="text-left"><strong>{{item.question}} <span style="color: red;" v-if="item.required">*</span></strong><br />{{item.description}}</td></template>
        <template #options="{item}"><td class="text-left w400" style="vertical-align: middle;"><span v-if="item.optionsLabels"><ul style="margin: 0px;"><li v-for="option in item.optionsLabels">{{option}}</li></ul></span></td></template>
        <template #actions="{item}">
          <td class="table_actions">
            <CButton color="secondary" size="sm" :disabled="!canMove(item, -1)" @click="moveQuestion(item, -1)" v-c-tooltip="{content: 'Subir', placement: 'top'}"><CIcon name="cil-chevron-top"/></CButton>
            <CButton color="secondary" size="sm" :disabled="!canMove(item, 1)" @click="moveQuestion(item, 1)" v-c-tooltip="{content: 'Bajar', placement: 'top'}"><CIcon name="cil-chevron-bottom"/></CButton>
            <CButton color="warning" size="sm" @click="updateQuestionModal(item)"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteQuestionModal(item)"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <QuestionModal ref="questionFormModal" :questions="questions" @store="storeProcess" @update="updateProcess"></QuestionModal>
    <DeleteModal ref="deleteQuestionFormModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import QuestionModal from './QuestionModal.vue'
import DeleteModal from '../../../components/global/DeleteModal.vue'

import ws from '../../../services/travels';
import store from '../../../store'

import moment from 'moment';
import moment_timezone from 'moment-timezone'

moment.tz.setDefault('America/Mexico_city')

export default {
  name: 'QuestionsTable',
  components: { QuestionModal, DeleteModal },
  props: {
    permissions: Array,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: 'Orden'},
          {key: 'type', label: 'Tipo'},
          {key: 'question', label: 'Pregunta'},
          {key: 'options', label: 'Opciones'},
          {key: 'actions', label: 'Acciones'}
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    id: 0,
    travel: {},
  },
  data() {
    return {
      toasts: [],
      title: 'Preguntas del Formulario',
      questions: [],
      students: [],
      payments: [],
      ps: []
    }
  },
  mounted: async function() {
    let _this = this;

    setTimeout(async function(){
      await _this.loadQuestions();
    }, 100);
  },
  methods: {
    canMove(item, direction) {
      const index = this.questions.findIndex(question => question.id == item.id);
      const targetIndex = index + direction;

      return index >= 0 && targetIndex >= 0 && targetIndex < this.questions.length;
    },
    async moveQuestion(item, direction) {
      if(!this.canMove(item, direction)){
        return;
      }

      const orderedQuestions = [...this.questions];
      const itemIndex = orderedQuestions.findIndex(question => question.id == item.id);
      const targetIndex = itemIndex + direction;

      [orderedQuestions[itemIndex], orderedQuestions[targetIndex]] = [orderedQuestions[targetIndex], orderedQuestions[itemIndex]];

      this.loading();
      const response = await ws.reorderQuestions(this.id, orderedQuestions.map(question => question.id));

      if(response.type == "success"){
        await this.loadQuestions();
      }

      this.showToast(response.type, response.message);
      this.loaded();
    },
    async loadQuestions () {
      const response = await ws.questions(this.id);
      const specialResponse = await ws.specialQuestions(this.id);
      const questions = response.type == "success" ? response.data : [];
      const specialQuestions = specialResponse.type == "success" ? specialResponse.data : [];

      this.questions = questions.concat(specialQuestions).sort((first, second) => first.position - second.position);
    },
    questionModal () {
      this.$refs.questionFormModal.storeModal(this.travel, 1, 0);
    },
    updateQuestionModal (item) {
      this.$refs.questionFormModal.updateModal(item.is_special, item);
    },
    deleteQuestionModal (item) {
      this.$refs.deleteQuestionFormModal.show("Eliminar Pregunta", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.storeQuestion(data);
      
      if(response.type == "success"){
        await this.loadQuestions();
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.updateQuestion(data);

      if(response.type == "success"){
        await this.loadQuestions();
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(data){
      this.loading();
      let response = await ws.deleteQuestion(data);

      if(response.type == "success"){
        await this.loadQuestions();
      }

      this.showToast(response.type, response.message);

      this.loaded();
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
